import { useCallback, useEffect, useRef, useState } from 'react';
import Notification from './Notification';

import { useNotificationStore } from '@/stores/notificationstore';
import { NotificationMessage } from '@/types';

export function Notifications() {
  const notificationMessages = useNotificationStore((state) => state.notificationMessages);
  const notificationsAllowed = useNotificationStore((state) => state.notificationsAllowed);
  const shift = useNotificationStore((state) => state.shift);
  const timer = useRef<NodeJS.Timeout | undefined>(undefined);
  const [msg, setMsg] = useState<NotificationMessage | undefined>(undefined);

  function clearTimer() {
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = undefined;
    }
  }

  const close = useCallback(() => {
    clearTimer();
    msg?.onClose?.();
    shift();
  }, [msg, shift]);

  useEffect(() => {
    clearTimer();
    if (!notificationsAllowed) return;

    if (!notificationMessages.length) {
      setMsg(undefined);
    } else {
      const current = notificationMessages[0];
      setMsg(current);
      if (current.timeoutSec) {
        timer.current = setTimeout(close, current.timeoutSec * 1000);
      }
    }
  }, [notificationMessages, notificationsAllowed, close]);

  if (!msg) return null;

  return <Notification key={msg.message} message={msg.message} close={close} severity={msg.severity} />;
}
